import request from '../../axios';

const DeleteStory = async (guid: string) => {
  await request.delete(`api/v2/store/delete-story-post/${guid}`);
};

export default DeleteStory;
